module.exports = __webpack_public_path__ + "img/ServiceCode.17918374.png";